export const computeTotalPages = (total, numberPerPage) =>
  Math.ceil(total / numberPerPage);

export const computeCurrentPage = (offset, numberPerPage) =>
  Math.ceil(offset / numberPerPage) + 1;

export const computeOffset = (pageNumber, numberPerPage) =>
  (pageNumber - 1) * numberPerPage;



// WEBPACK FOOTER //
// ./services/paginationComputer.js